module.exports = __webpack_public_path__ + "img/icon3.f6a60c12.gif";